import xlsx, { ISettings, IJsonSheet, IColumn, IContent } from "json-as-xlsx";
import moment from "moment";
import {
  RelatorioReservasItem,
  RelatorioReservasPdfDataResponse,
} from "features/relatorios/typings";
import { StatusReservaEnum } from "core/features/reservas/typings";
import { defaultContentMapperXlsx } from "infra/packages/json-as-xlsx/index";

export function exportExcelRelatorioReservas({
  data,
}: {
  data: RelatorioReservasPdfDataResponse;
}) {
  const settings: ISettings = {
    fileName: `Relatório de Reservas - ${moment().format("DD_MM_YYYY")}`,
    extraLength: 3,
    writeOptions: {},
  };

  const columnsReservas = getColumnsReservas();

  const sheets: IJsonSheet[] = [];

  sheets.push({
    sheet: `Reservas `.slice(0, 31),
    columns: columnsReservas,
    content: data.items.map(defaultContentMapperXlsx),
  });

  xlsx(sheets, settings);
}

function getColumnsReservas() {
  const columns: IColumn[] = [];

  columns.push({
    label: "Data de criação",
    value: (row: IContent) =>
      `${
        row.createdAt
          ? moment(row.createdAt as string).format("DD/MM/YYYY")
          : ""
      }`,
  });

  columns.push({
    label: "Data do evento",
    value: (row: IContent) =>
      `${
        row.dataEvento
          ? moment(row.dataEvento as string).format("DD/MM/YYYY HH:mm")
          : ""
      }`,
  });

  columns.push({
    label: "Área comum",
    value: (row: IContent) =>
      (row as unknown as RelatorioReservasItem).areaComum,
  });

  columns.push({
    label: "Valor",
    format: "#,###0.00",
    value: (row: IContent) =>
      (row as unknown as RelatorioReservasItem).valor || 0,
  });

  columns.push({
    label: "Responsável",
    value: (row: IContent) =>
      (row as unknown as RelatorioReservasItem).proprietario,
  });

  columns.push({
    label: "Status",

    value: (row: IContent) =>
      `${
        row.status === StatusReservaEnum.Confirmada
          ? ("Confirmada" as string)
          : row.status === StatusReservaEnum.Pendente
          ? ("Pendente" as string)
          : row.status === StatusReservaEnum.AguardandoPagamento
          ? ("Aguardando Pagamento" as string)
          : row.status === StatusReservaEnum.Cancelada
          ? ("Cancelada" as string)
          : null
      }`,
  });

  columns.push({
    label: "Origem",
    value: (row: IContent) => `${row.origem || ""}`,
  });

  columns.push({
    label: "Data de cancelamento",
    value: (row: IContent) =>
      `${
        row.dataCancelamento
          ? moment(row.dataCancelamento as string).format("DD/MM/YYYY HH:mm")
          : ""
      }`,
  });

  columns.push({
    label: "Quem cancelou",
    value: (row: IContent) =>
      (row as unknown as RelatorioReservasItem).responsavelCancelamento
        ? row.responsavelCancelamento
        : "",
  });

  return columns;
}
